import { Budget } from "@/services/cloudchipr.api";
import { getPlannedBudgetsWithLabels } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/getPlannedBudgetsWithLabels";
import { isCurrentPlannedBudgetPeriod } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/isCurrentPlannedBudgetPeriod";

export const budgetAmountCellValueGetter = (
  budget: Budget | undefined,
  quarterStartMonth?: number,
) => {
  if (!budget) {
    return null;
  }

  if (budget.type === "fixed") {
    return budget.amount;
  }

  const { period, planned_amounts, start_date } = budget;

  const plannedBudgets = getPlannedBudgetsWithLabels({
    period,
    plannedAmounts: planned_amounts ?? undefined,
    startDate: start_date,
    quarterStartMonth,
  });

  const currentPlannedBudget = plannedBudgets.find((plannedBudget) =>
    isCurrentPlannedBudgetPeriod(
      plannedBudget.label,
      period,
      quarterStartMonth,
    ),
  );

  return currentPlannedBudget?.amount ?? null;
};
